import grow2792DetailsFakeFeatures from '~pricing/experiments/grow_2792_pnp_refresh_v1/transformers/details/groupings/fakeFeatures';

export default [...grow2792DetailsFakeFeatures];
